import { Component, Input, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { CheckPermissionsPipe } from '../../../pipes/check-permissions/check-permisions.pipe';
import { TabPermissions } from '../../../types/tab-permission.type';

@Component({
  selector: 'acp-reporting-tab-dropdown, [acp-reporting-tab-dropdown]',
  templateUrl: './reporting-tab-dropdown.component.html',
  imports: [RouterLink, RouterLinkActive, CheckPermissionsPipe],
})
export class ReportingTabDropdownComponent implements OnInit {
  @Input() reportingTabPermissions: TabPermissions = {};

  ngOnInit(): void {}
}
